import { InputNumber as AntInputNumber } from 'antd';
import { useRef } from 'react';
import { useEffect } from 'react';

/**
 * Wrapper component for Ant Design InputNumber
 *
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design InputNumber functionality including min, max, step, and precision options.
 *
 * @component
 * @example
 * import { InputNumber } from '../GeneralComponents/ui';
 *
 * <InputNumber min={1} max={10} defaultValue={3} />
 * <InputNumber step={0.1} precision={2} />
 * <InputNumber size="large" min={1} max={100000} defaultValue={3} />
 *
 * @see https://ant.design/components/input-number/ - Ant Design InputNumber documentation
 */
const InputNumber = (props) => {
  const ref = useRef(null);

  useEffect(() => {
    if (props.autoFocus === true) {
      const interval = setInterval(() => {
        if (ref.current) {
          ref.current.focus();
          clearInterval(interval);
        }
      }, 100);
    }
  }, []);

  return <AntInputNumber {...props} ref={ref} />;
};

export default InputNumber;
